import { BreakpointTrackerContext } from '@jutro/layout';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useDataRefresh, ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import PropTypes from 'prop-types';
import _, { update } from 'lodash';
import React, { useCallback, useContext, useState, useEffect } from 'react';
import metadata from './TWIAAdditionalInsuredDetails.metadata.json5';
import messages from './TWIAAdditionalInsuredDetails.messages.js';
import styles from '../TWIAAdditionalInterestComponent.module.scss';

function TWIAAdditionalInsuredDetails(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const { item, saveData, cancelData, isInvalid, showErrors, onValidate } = props;
    const {
        isComponentValid,
        onValidate: setComponentValidation,
    } = useValidation('TWIAAdditionalInsuredDetails');

    const viewModelService = useContext(ViewModelServiceContext);
    const [additionalInfoVM, setAdditionalInfoVM] = useState(item);
    const { refreshData } = useDataRefresh();
    const personContact = viewModelService.productMetadata.get('pc').types.getTypelist('typekey.ContactType').getCode('person');
    const companyContact = viewModelService.productMetadata.get('pc').types.getTypelist('typekey.ContactType').getCode('company');


    useEffect(() => {
        if (onValidate && !_.isNull(isComponentValid)) {
            onValidate(isComponentValid, 'TWIAAdditionalInsuredDetails');
        }
    }, [isComponentValid, onValidate]);

    useEffect(() => {
        isInvalid(isComponentValid, 'TWIAAdditionalInsuredDetails');
    }, [isInvalid, isComponentValid])

    const contactTypeChange = useCallback((value, path) => {
        _.set(additionalInfoVM, path, value);

        if (value === 'Person') {
            _.set(additionalInfoVM, 'contactType_TWIA.value', personContact)
        } else {
            _.set(additionalInfoVM, 'contactType_TWIA.value', companyContact)
        }

        setAdditionalInfoVM(additionalInfoVM);
        refreshData();
    }, [additionalInfoVM, companyContact, personContact, refreshData]);

    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        name: {
            visible: additionalInfoVM?.subtype.value === 'Company'
        },
        firstName: {
            visible: additionalInfoVM?.subtype.value === 'Person'
        },
        lastName: {
            visible: additionalInfoVM?.subtype.value === 'Person'
        },
        realationshipToNamedInsured: {
            path: 'policyContactRoles.children[0].policyAdditionalNamedInsured.relationshipToPrimaryNamedInsured'
        },
        saveButton: {
            disabled: !isComponentValid,
        }
    };

    const saveAdditionalInsured = () => saveData(additionalInfoVM);

    const cancelAdditionalInsured = () => {
        isInvalid(true, 'TWIAAdditionalInsuredDetails');
        cancelData();
    }

    const writeValue = useCallback(
        (value, path) => {
            _.set(additionalInfoVM, `${path}.value`, value);
            setAdditionalInfoVM(additionalInfoVM);
            refreshData();
        },
        [additionalInfoVM, refreshData]
    );

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onSave: saveAdditionalInsured,
            onCancel: cancelAdditionalInsured,
            onContactTypeChange: contactTypeChange,
        },
    };


    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={additionalInfoVM}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            onValueChange={writeValue}
            onValidationChange={setComponentValidation}
            showErrors={showErrors}
        />
    );
}

TWIAAdditionalInsuredDetails.propTypes = {
    item: PropTypes.shape({}).isRequired,
    saveData: PropTypes.func.isRequired
};

export default TWIAAdditionalInsuredDetails;
